import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
// import CryptoJS from 'crypto-js';
import Pagination from './../shared/pagination'
import {
	Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
export default {
	name: 'warehouseclient',
	components: {
		Paginate,
		Pagination,
		VueElementLoading
	},
	data: function() {
		return {
			// currentPage: 0,
			// totalRows:0,
			//modalShow used for close the active/inactive modal(default
			editwarehousemodal: false,
			addwarehouseclientmodal: false,
			warehouseclientaction: '',
			listClientData: [],
			listWarehouseClient: [],
			checkedWarehouse: [],
			listWarehouseData: [],
			// pageno: 0,
			// totalPage: 0,
			totalPage: 0,
			totalRows:0,
			currentPage: 1,
			pageLimit:20,
			isLoading: false,
			resultCount: '',
			pageCount: '',
			client: '',
			clientid: ''
		}
	},
	created: function() {},
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		}
	},
	// when a page loads,mounted() will be call
	mounted() {
		this.pageno = 0
		this.getClientList()
		this.getWarehouseList()
	},
	methods: {

		//get Client list as per warehouse
		getClientList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageNo = this.pageCount = 0;
			this.input = ({});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listClientData = result.data.data;
					this.isLoading = false;
					this.totalRows = result.data.data.length;
					this.resultCount = result.data.data.length;
					if (this.totalRows < 20) {
						this.totalPage = 1;
					} else {
						this.totalPage = Math.ceil(this.totalRows / 20);
					}
				}, error => {
					console.error(error);
				});
		},

		//to get Warehouse Client list from warehouseclient db
		getWarehouseClientList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				offset: (this.currentPage - 1) * 20,
				limit: 20,
				clientid: Number(this.client)
			})
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'GetWarehouseClientList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listWarehouseClient = result.data.data
					for (var i = 0; i < result.data.data.length; i++) {
						this.checkedWarehouse.push(result.data.data[i].warehouseid);
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
				})
		},

		//update warehose client field
		editWarehouseClient() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.client,
				warehouseid: this.checkedWarehouse
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'editWarehouseClient',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (response.data.errorCode == 0) {
						this.$alertify.success(response.data.msg)
						this.addwarehouseclientmodal = false
						this.getClientList();

					} else {
						(response.data.errorCode == -1)
						this.$alertify.error(response.data.msg)
					}

				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},





		//get warehouse list for checkbox of warehouseclient
		getWarehouseList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listWarehouseData = result.data.data
				}, error => {
					console.error(error)
				})
		},

		//to get target id in edit action
		getWarehouseClientRowData(data) {
			this.warehouseclientaction = 'edit';
			this.addwarehouseclientmodal = true;
			this.$validator.reset();
			this.errors.clear();
			// this.id = data.id;
			this.client = data.clientid;
			this.checkedWarehouse = [];
			this.addeddate = data.addeddate;
			this.getWarehouseClientList();
		},

		// to close  form
		closeAddWarehouseClientModal() {
			this.addwarehouseclientmodal = false
		},
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * 10
		// 	this.getClientList()
		// },
		onPageChange(page) {
		  this.currentPage = page;
		  this.getClientList()
		},
		//validate all form fields on onsubmit()
		onSubmit: function(event) {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model)
				event.target.reset();
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/warehouseclient/warehouseclient.component.js